export default __webpack_public_path__ + "static/media/lorawan-asset-tracking.00fa7468.jpg";